export const FILE_STORAGE_CONTAINER = 'coretemplates';
export const FILE_PROGRESS_PARAM = 'loadedBytes';
export const FILE_COUNT_MAX = 1;
export const FILE_TYPE_ERROR =
    'File format or File extension is invalid. File format is not supported by the Application.';
export const FILE_COUNT_ERROR = 'Multiple files are not allowed';
export const FILE_PREVIEW_PROGRESS = 'We are generating preview';
export const DATA_EDITOR_SYNC_PROGRESS = 'We are syncing data';
export const FILE_UPLOAD_SUCCESS_MESSAGE = 'File has been uploaded successfully';
export const FILE_UPLOAD_ERROR_MESSAGE = 'File upload failed';
export const ERROR_CORRECTED_MESSAGE =
    'All errors are fixed. Please click on Save button to view the changes in the tool';
export const CORE_TEMPLATE_FILE_NAME = 'GBB_Input_Template.xlsx';
export const DATA_SYNC_IN_PROGRESS = `Your changes are getting saved. To propagate your changes to external Application, click on 'Map to GBB Public' after sync completion`;
